import { useLocation, useParams } from 'react-router-dom';
import { differenceInMinutes, format, fromUnixTime } from 'date-fns';

export interface ValidationResult {
  isValid: boolean;
  errorMessage?: string;
}

export default function useAppointmentValidation(): ValidationResult {
  const location = useLocation();
  const { URLRoomName } = useParams<{ URLRoomName?: string }>();
  const queryParams = new URLSearchParams(location.search);
  const identity = queryParams.get('identity');
  const time = queryParams.get('time');

  if (!URLRoomName || !identity || !time) {
    return {
      isValid: false,
      errorMessage: 'Fill correct data',
    };
  }

  const now = new Date();
  const appointmentDate = fromUnixTime(parseInt(time));
  const diff = differenceInMinutes(appointmentDate, now);
  if (diff > 5) {
    return {
      isValid: false,
      errorMessage: `Appointment starts at ${format(
        appointmentDate,
        'MM/dd/yyyy hh:mm a'
      )} (your local time). You can join 5 minutes before.`,
    };
  }

  return {
    isValid: true,
  };
}
